import { render, staticRenderFns } from "./DashboardPieChart.vue?vue&type=template&id=d445b36a&scoped=true&"
import script from "./DashboardPieChart.vue?vue&type=script&lang=js&"
export * from "./DashboardPieChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPieChart.vue?vue&type=style&index=0&id=d445b36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d445b36a",
  null
  
)

export default component.exports